import { render, staticRenderFns } from "./DactilitisBodyModel.vue?vue&type=template&id=77e1a336&scoped=true&"
import script from "./DactilitisBodyModel.vue?vue&type=script&lang=js&"
export * from "./DactilitisBodyModel.vue?vue&type=script&lang=js&"
import style0 from "./DactilitisBodyModel.vue?vue&type=style&index=0&id=77e1a336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e1a336",
  null
  
)

export default component.exports